/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type HmacImpl = (obj: Record<string, unknown>) => string;
export let encoderImpl: HmacImpl;
export type DecodeHmacImpl = (s: string) => Record<string, unknown>;
export let decoderImpl: DecodeHmacImpl;
export function setEncoder(encoder: HmacImpl): void {
  encoderImpl = encoder;
}
export function setDecoder(decoder: DecodeHmacImpl): void {
  decoderImpl = decoder;
}
function sortKeysForObj(o: Record<string, unknown>): Record<string, unknown> {
  return Object.keys(o)
    .sort()
    .reduce((accumulator, currentKey) => {
      accumulator[currentKey] = o[currentKey];
      return accumulator;
    }, {} as Record<string, unknown>);
}
setEncoder((o: Record<string, unknown>) => JSON.stringify(sortKeysForObj(o)));
setDecoder(s => sortKeysForObj(JSON.parse(s)));
